// removed by extract-text-webpack-plugin
module.exports = {"error":"DmcaConfirmations_error_3beEy"};